import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "next-i18next";
import CategoryProductsList from "./products-list";
import { getCategoryProducts } from "@/services/elasticsearch/category";
import useSWRMutation from "swr/mutation";
import { useRouter } from "next/router";
import useFilterData from "@/hooks/useSearchParams";
import { getCookie } from "cookies-next";
import dynamic from "next/dynamic";

const Pagination = dynamic(() => import("../pagination"));
const ResultsCount = dynamic(() => import("./results-count"));
const Sorting = dynamic(() => import("../sorting"));
function ProductsWrapper({
  serSideProducts,
  serverSideTotalProduct,
  categoryId,
  filters,
  serverSidePages,
  device,
}) {
  const { t } = useTranslation("category");

  const regionId = getCookie("region_id");
  const { query, locale } = useRouter();
  const currentPage = Number(query?.p) || 1;
  const pageSize = 32;
  const { setFilterQueryHandler } = useFilterData();

  const filterCodes = useMemo(() => filters.map((f) => f.code), [filters]);

  const [products, setProducts] = useState([...serSideProducts]);
  const [totalProduct, setTotalProduct] = useState(serverSideTotalProduct);
  const [pages, setPages] = useState(serverSidePages);

  const { trigger } = useSWRMutation(
    () => [
            categoryId,
            pageSize,
            currentPage - 1,
            query,
            filterCodes,
            locale,
            regionId,
          ],
    async () =>
      await getCategoryProducts({
        handshake: undefined,
        categoryId,
        pageSize,
        regionId,
        pageNo: currentPage - 1,
        query,
        filterCodes,
      }),
    {
      revalidateOnMount: false,
      revalidateOnFocus: false,
      onError: (err) => {
        console.error("Error fetching data:", err);
      },
      onSuccess: (res) => {
        setProducts(res.products);
        setTotalProduct(res.totalProduct);
        setPages(res.pages + 1);
      },
    }
  );
  useEffect(() => {
    trigger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale, regionId]);

  useEffect(() => {
    trigger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <>
      <div className="max-[768px]:hidden flex justify-between items-center border rounded-md p-3">
        <Sorting t={t} />
        <ResultsCount t={t} currentPage={currentPage} total={totalProduct} />
      </div>
      <CategoryProductsList products={products} t={t} />
      <Pagination
        currentPage={currentPage}
        pageCount={pages}
        onPageChange={(page) => setFilterQueryHandler({ p: page })}
        t={t}
        device={device}
      />
    </>
  );
}

export default ProductsWrapper;
